export enum AerospaceDamageId {
  GeneralSurfaceRust = 'general-surface-rust',
  Pitting = 'pitting',
  Exfoliation = 'exfoliation',
  Crack = 'crack',
  Dent = 'dent',
  Puncture = 'puncture',
  Delamination = 'delamination',
  Debonding = 'debonding',
  Buckling = 'buckling',
  FluidLeak = 'fluid-leak',
  LightningStrike = 'lightning-strike',
  PaintDefect = 'paint-defect',
}

const isAerospaceDamageId = (value: unknown): value is AerospaceDamageId => {
  return (
    typeof value === 'string' &&
    (Object.values(AerospaceDamageId) as string[]).includes(value)
  )
}

export class KVAerospaceAnnotation {
  selected: AerospaceDamageId[]

  constructor() {
    this.selected = []
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  static fromJSON(json: any): KVAerospaceAnnotation {
    const annotation = new KVAerospaceAnnotation()

    if (Array.isArray(json)) {
      annotation.selected = json.filter(isAerospaceDamageId)
    } else if (json && Array.isArray(json.selected)) {
      annotation.selected = json.selected.filter(isAerospaceDamageId)
    }

    return annotation
  }

  static toJSON(
    annotation: KVAerospaceAnnotation
  ): Record<string, string[] | undefined> {
    return {
      selected: [...annotation.selected],
    }
  }
}
